import s from "./IconsToggle.module.scss";

export const IconsToggle = ({
  value,
  setValue,
  options,
}: {
  setValue: (value: string) => void;
  value: string;
  options: { label: string; value: string; icon: React.ReactNode }[];
}) => {
  return (
    <div className={s.row}>
      {options.map((option) => {
        return (
          <div
            key={option.value}
            className={`${s.periodButton} ${
              value === option.value ? s.selected : ""
            }`}
            onClick={() => setValue(option.value)}
          >
            {option.icon}
            {option.label}
          </div>
        );
      })}
    </div>
  );
};
